var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "19px",
    viewBox: "0 0 14 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Delete/Dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Internal-Customers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SkinHealth_Internal_Customers_ListView_Selected",
    transform: "translate(-471.000000, -211.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Selection",
    transform: "translate(353.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(113.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00941915,19.0915751 C6.00941915,20.1956044 6.90800628,21.0989011 8.00627943,21.0989011 L15.9937206,21.0989011 C17.0919937,21.0989011 17.9905808,20.1956044 17.9905808,19.0915751 L17.9905808,7.04761905 L6.00941915,7.04761905 L6.00941915,19.0915751 Z M18.989011,4.03663004 L15.4945055,4.03663004 L14.4960754,3.03296703 L9.50392465,3.03296703 L8.50549451,4.03663004 L5.01098901,4.03663004 L5.01098901,6.04395604 L18.989011,6.04395604 L18.989011,4.03663004 Z",
    id: "Shape",
    fill: "#666666",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.19e2d26d7431f8809f1602418cbd97b2.svg";
export { ForwardRef as ReactComponent };